import type { NextPage } from 'next'
import Break from 'componentsUnits/break'
import ComponentHeader from 'componentsUnits/componentHeader'
import { Size } from 'types/size'
import { isArraysHaveCommonStrings } from 'helpers/checker'
import { joinClassnames } from 'helpers/classNames'
import styles from './EntrySC.module.scss'
import { Activity } from 'types/user'
import Subtitle from 'componentsUnits/subtitle'
import { EntryDateIndex } from 'reducers/postReducer'
import EntryComponent from './entryComponent'
import { Type } from 'types/type'
import { isDev } from 'app/general'
import { Entry } from 'types/entry'

interface Props {
  entryDateIndex?: EntryDateIndex[]
  activeInterests?: string[]
  entries?: Entry[]
  title?: string
  showAll?: boolean
  column?: boolean
  showorganiser?: boolean
  activity?: Activity
  noEntriesText?: string
  hideEventTitle?: boolean
}

const EntryScrollHorizontalComponent: NextPage<Props> = (props: Props) => {
  const className = joinClassnames([
    styles.component_list_wrapper,
    props.column && styles.column,
  ])

  const createHeaderObject = () => {
    if (props.title && props.title !== "")
      return (
        <ComponentHeader
          title={props.title}
          buttonText={''}
          buttonOnClick={() => {
            isDev && console.log('clicked')
          }}
        />)
    else return <></>
  }

  const generateEntryComponents = () => {
    let ren: JSX.Element[] = []
    if (!props.entryDateIndex) {
      props.entries?.map((entry: Entry, i: number) => {
        if (props.activeInterests && props.activeInterests.length > 0) {
          if (props.activeInterests.includes("All") || isArraysHaveCommonStrings(
            props.activeInterests as string[],
            entry.interests as string[],
          )) {
            ren.push(
              <EntryComponent
                key={i}
                entry={entry}
              />
            )
          }
        } else {
          ren.push(
            <EntryComponent
              key={i}
              entry={entry}
            />
          )
        }
      })
      return ren
    }
    props.entryDateIndex && props.entryDateIndex.map((edi: EntryDateIndex, i: number) => {

      if (props.showAll) {
        ren.push(
          <EntryComponent
            hideOptions
            hideEventTitle={props.hideEventTitle}
            entryDateIndex={edi}
            // showorganiser={props.showorganiser}
            // activity={props.activity}
            key={i}
          // entryId={c.entryId}
          // entry={props.entries[c.entryId]}
          />
        )
      }
      // else if (
      //   isArraysHaveCommonStrings(
      //     props.activeInterests as string[],
      //     props.entries[edi.entryId].interests as string[],
      //   )
      // ) {
      //   ren.push(
      //     <EntryComponent
      //       key={i} entryDateIndex={edi} />
      //   )
      // }
    })
    return ren
  }

  return (
    <div className={styles.container}>
      {createHeaderObject()}
      <div className={className}>
        {props.entryDateIndex?.length === 0 && props.noEntriesText && (
          <Subtitle text={props.noEntriesText} type={Type.t1} size={Size.xSmall} />
        )}
        {generateEntryComponents()}
      </div>
      <Break />
    </div>
  )
}

export default EntryScrollHorizontalComponent
